import axios from 'axios';

export const actionTypes = (typeName, prefix = null) => {
  const name = prefix ? prefix + '_' + typeName : typeName;
  return {
    [typeName]: {
      START: `${name}_START`,
      SUCCESS: `${name}_SUCCESS`,
      ERROR: `${name}_ERROR`,
    },
  };
};

export const instance = axios.create({
  baseURL: `${window.location.origin}/${process.env.REACT_APP_BACKEND_FLOWABLE_CONTEXT_PATH}`,
  withCredentials: true,
});

export const documentKeys = payload => {
  const additionalDocumentsList = [
    'prclNumber',
    'secCode',
    'certificationYear',
    'reductionCo2',
    'energyConsumption',
    'otherDocs',
  ];

  return Object.keys(payload).filter(
    v =>
      v.startsWith('ben') ||
      v.startsWith('aud') ||
      additionalDocumentsList.includes(v)
  );
};

export const carrierKeys = payload => {
  const additionalCarrierKeysList = [
    'companyName',
    'abiVat',
    'regDate',
    'mainKAD',
    'mainKADDescription',
    'companyLegalType',
    'abiStreetFull',
    'abiStreet',
    'abiTk',
    'abiPerfecture',
    'birthDate',
    'abiDistrict',
    'invMob',
    'website',
    'invMail',
    'legalSurname',
    'legalFather',
    'legalAdt',
    'legalName',
    'legalVat',
    'legalPhone',
    'legalPhoneValidated',
    'legalVat',
    'legalEmail',
    'legalEmailValidated',
    'legalPhoneMobile',
    'legalPhoneMobileValidated',
    'contactSurname',
    'contactName',
    'contactVat',
    'contactPhone',
    'contactPhoneValidated',
    'contactVat',
    'contactEmail',
    'contactEmailValidated',
    'totalAmountSorefsis',
    'otherReasonCheck',
    'otherReasonDescription',
    'checkUniqueAfm',
    'checkUniqueKaek',
    'contactPersonFlag',
    'rejectKtpReason',
    'rejectKtpMessage',
    'buildName',
    'buildUsage',
    'buildYear',
    'buildDistrict',
    'buildAddress',
    'buildStreet',
    'buildTk',
    'buildPerfecture',
    'buildMunicipalityName',
    'powerSupNo',
    'usableArea',
    'totalArea',
    'schoolGrade',
    'coHousing',
    'schoolGradeCo',
    'coHousingName',
    'degDays',
    'thermIns',
    'amountThermIns',
    'amountThermInsFpa',
    'shellReplace',
    'amountShellReplace',
    'amountShellReplaceFpa',
    'upgradeSys',
    'amountUpgradeSys',
    'amountUpgradeSysFpa',
    'otherServices',
    'amountOtherServices',
    'amountOtherServicesFpa',
    'totalCost',
    'totalFpa',
    'totalCostWithFpa',
    'rejectAuditorReason',
    'rejectAuditorMessage',
    'withdrawCommitteeReason',
    'withdrawCommitteeMessage',
    'bnkName',
    'bnk',
    'iban',
    'hasAlreadySavedIban',
    'hasAlreadySavedBnkName',
    'hasAddedIbanAndBank',
  ];
  return Object.keys(payload).filter(
    v => v.startsWith('abi') || additionalCarrierKeysList.includes(v)
  );
};

export const bankOptions = [
  { label: 'Alpha Bank', value: 'Alpha Bank', id: 'alpha' },
  { label: 'Attica Bank', value: 'Attica Bank', id: 'attica' },
  { label: 'Eurobank', value: 'Eurobank', id: 'eurobank' },
  { label: 'Optima Bank', value: 'Optima Bank', id: 'optima' },
  { label: 'Εθνική Τράπεζα', value: 'Εθνική Τράπεζα', id: 'nbg' },
  {
    label: 'Παγκρήτια Τράπεζα',
    value: 'Παγκρήτια Τράπεζα',
    id: 'pancreta',
  },
  { label: 'Τράπεζα Πειραιώς', value: 'Τράπεζα Πειραιώς', id: 'pireus' },
];

export const mapBankOptionsValueToId = value =>
  bankOptions.find(bank => bank.value === value)?.id;

export const mapBankOptionsIdToValue = id =>
  bankOptions.find(bank => bank.id === id)?.value;

export const AssetKeys = payload =>
  Object.keys(payload).filter(
    v =>
      v.startsWith('businessPlanAssets') ||
      v.startsWith('InvestmentTotalAmountTable') ||
      v.startsWith('businessPlanCoverage') ||
      v.startsWith('mainKads') ||
      v.startsWith('addKads')
  );

export const termsKeys = payload =>
  Object.keys(payload).filter(v => v.startsWith('term'));

export const xedmKeys = payload =>
  Object.keys(payload).filter(v => v.startsWith('details'));

export const objectionInvestorKeys = payload => {
  return Object.keys(payload.variables).filter(v => v.startsWith('objInv'));
};

export const objectionCommitteeKeys = payload => {
  return Object.keys(payload.variables).filter(v =>
    v.startsWith('objCommittee')
  );
};

export const projectPlanInfoKeys = payload => {
  const additionalProjectPlanInfoKeysList = [
    'projectPlans',
    'messages',
    'timestamp',
  ];
  return Object.keys(payload).filter(v =>
    additionalProjectPlanInfoKeysList.includes(v)
  );
};
